import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Icon,
  Stack,
} from '@hurdl/design-system';
import { Users } from 'lucide-react';
import { type ReactElement } from 'react';

/**
 * The panel's own operator administration (panel-admin).
 *
 * This is the Admin_Panel's administration, not a per-Product capability page: the
 * operators who use the panel, their roles and access. The Support/Users capability the
 * full Admin_Panel programme composes is not built in this minimal build, so there is no
 * data to show — but a glance should read "not built yet", a clean placeholder, rather
 * than the capability-absent alert a Declared_Page shows. The panel's own Users is a
 * section of the shell, so it is a quiet "coming soon", not an outage.
 *
 * The one `h1` is the page's; the `main` landmark is the Layout's.
 */
export function UsersPage(): ReactElement {
  return (
    <Stack gap="large">
      <Stack gap="small">
        <h1 className="font-hurdl-display text-hurdl-heading font-hurdl-semibold">
          Users
        </h1>
        <p className="text-hurdl-body text-hurdl-muted-foreground">
          The operators with access to this panel.
        </p>
      </Stack>

      <Card>
        <CardContent>
          <Stack gap="medium" align="centre" className="py-hurdl-8 text-center">
            <span className="text-hurdl-muted-foreground">
              <Icon icon={Users} size="large" label="Users" />
            </span>
            <Stack gap="small" align="centre">
              <CardTitle>Coming soon</CardTitle>
              <CardDescription>
                Operator accounts and roles arrive with the full Admin panel.
              </CardDescription>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
